//#region src/executor.ts
/** SQLite drivers disagree on booleans and undefined; drizzle can emit both */
function normalizeParams(params) {
	return params.map((param) => {
		if (param === void 0) return null;
		if (typeof param === "boolean") return param ? 1 : 0;
		if (param instanceof Date) return param.toISOString();
		return param;
	});
}
//#endregion
export { normalizeParams as t };

//# sourceMappingURL=executor-DSji1iQ0.js.map